import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    HCRoutes: [],
    HCNotice: []
  },
  getters: {

  },
  actions: {

  },
  mutations: {
    setNotice(state, params) {
      state.HCNotice.push(params)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js